import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "swiper/css";
import "swiper/css/pagination";
import { appRoutes } from "./routes/appRoutes";
import { mobileRoutes } from "./routes/mobileRoutes";
import { websiteRoutes } from "./routes/websiteRoutes";
import { domain, isLocalhost, SUBDOMAINPREFIXES } from "./utils/constants";

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

const getRouter = () => {
  let r: RouteObject[] = [];

  if (isLocalhost) {
    r = [...websiteRoutes, ...appRoutes, ...mobileRoutes];
  } else {
    if (domain.startsWith(SUBDOMAINPREFIXES["member"])) {
      r = appRoutes;
    } else if (domain.startsWith(SUBDOMAINPREFIXES["mobile"])) {
      r = mobileRoutes;
    } else {
      r = websiteRoutes;
    }
  }

  return createBrowserRouter(r);
};

function App() {
  return (
    <>
      <RouterProvider router={getRouter()} />
    </>
  );
}

export default App;
